function initLocalMessagesCache() {
    var localPrompts = [
        {
            role: 'user',
            content: 'Hello!!!',
        },
    ];
    var localMessages = [];
    return {
        getLocalPrompts: function () { return localPrompts; },
        setLocalPrompts: function (msg, msgs) {
            if (msgs && Array.isArray(msgs)) {
                localPrompts = msgs;
            }
            else if (msg) {
                localPrompts.push(msg);
            }
        },
        getLocalMessages: function () { return localMessages; },
        setLocalMessages: function (msg, msgs) {
            if (msgs && Array.isArray(msgs)) {
                localMessages = msgs;
            }
            else if (msg) {
                localMessages.push(msg);
            }
        },
    };
}
/**
 * local cache for messages
 * @public
 */
export var localCache = initLocalMessagesCache();
//# sourceMappingURL=localMessagsCache.js.map